import React, { useState, useEffect } from "react";
import "../../App.css";
import logo from "../../images/DK_logo.png";
import { Link } from "react-router-dom";
import CompanySizeService from "../../services/companySizeService";
import CountryPhoneCodeService from "../../services/countryPhoneCodeService";
import RegisterService from "../../services/registerService";
import {
  HEADERS,
  CheckUserEmail,
  SubscribeOuter,
  checkOrgName,
  checkOrgCode,
  OtpVerifyOuter,
} from "../api";
import { useNavigate } from "react-router-dom";
import { useForm } from "react-hook-form";
import { useLocation } from "react-router-dom";
import { registerPaidSubscription } from "../../services/apiFunctions";
import Swal from "sweetalert2";
import { useSearchParams } from "react-router-dom";
import axios from "axios";

const Registration = () => {
  const [step, setStep] = useState(1);
  const [countries, setCountries] = useState([]);
  const [companySize, setCompanySize] = useState([]);
  const [searchParams] = useSearchParams();
  const selectedPlanId = parseInt(searchParams.get("planId")) || 3;
  const selectedPlanPrice = parseFloat(searchParams.get("planPrice"));
  const [userId, setUserId] = useState(null);
  const [accountNumber, setAccountNumber] = useState("");
  const [isPasswordVisible, setIsPasswordVisible] = useState(false);
  const [emailValid, setEmailValid] = useState(false);
  const [orgNameValid, setOrgNameValid] = useState(false);
  const [orgCodeValid, setOrgCodeValid] = useState(false);
  // console.log("Plan ID:", selectedPlanId);
  // console.log("Plan Price:", selectedPlanPrice);
  const {
    register: registerForm1,
    handleSubmit: handleSubmitForm1,
    formState: { errors: errorsForm1 },
    watch: watchForm1,
  } = useForm();
  const {
    register: registerForm2,
    handleSubmit: handleSubmitForm2,
    formState: { errors: errorsForm2 },
    setValue,
    getValues,
  } = useForm({
    defaultValues: {
      company_size: 1,
    },
  });
  const togglePasswordVisibility = () => {
    setIsPasswordVisible((prevState) => !prevState);
  };

  const [formData, setFormData] = useState({
    form1: {},
    form2: {},
  });

  const passwordForm1 = watchForm1("users_password");

  const onSubmitForm1 = (data) => {
    setFormData((prevData) => ({
      ...prevData,
      form1: data,
    }));

    const hasFormErrors = Object.keys(errorsForm1).length > 0;
    const hasApiErrors = errorMessage !== "";

    if (!hasFormErrors && !hasApiErrors) {
      setStep(step + 1);
    }
  };
  const onSubmitForm2 = async (data) => {
    setFormData((prevData) => ({
      ...prevData,
      form2: data,
    }));

    const form1Valid = Object.keys(errorsForm1).length === 0 && !errorMessage;
    const form2Valid =
      Object.keys(errorsForm2).length === 0 && !errorMessage1 && !errorMessage2;

    if (form1Valid && form2Valid) {
      setStep(step + 1);
    }
  };

  const handleCombinedSubmit = async () => {
    const form1Valid = Object.keys(errorsForm1).length === 0;
    const form2Valid = Object.keys(errorsForm2).length === 0;

    if (form1Valid && form2Valid) {
      const { terms, confirm_users_password, ...restForm1 } = formData.form1;
      const combinedData = {
        ...restForm1,
        ...formData.form2,
        company_size: parseInt(getValues("company_size"), 10),
        plan_id: selectedPlanId,
      };

      // console.log("combinedData", combinedData);

      const registerServiceResponses = await RegisterService(combinedData);
      if (registerServiceResponses.response_code === "0000") {
        const userIdFromResponse = registerServiceResponses?.data?.[0]?.userid;
        // console.log("response success", registerServiceResponses);
        setUserId(userIdFromResponse);
        setStep(4);

        Swal.fire({
          icon: "success",
          title: "Registration Successful!",
          text: "User registered successfully.",
          confirmButtonColor: "#2d7d9f",
          confirmButtonText: "OK",
        }).then(() => {
          navigate("/login");
        });
      } else {
        setErrorMessage(registerServiceResponses.response_description);
        // console.log("failed", registerServiceResponses);
      }
    }
  };

  const handleAccountSubmit = async () => {
    const payload = {
      plan_price: String(selectedPlanPrice),
      account_number: accountNumber,
    };
    // console.log("Payload:", payload);
    try {
      const response = await axios.post(
        SubscribeOuter,
        JSON.stringify(payload),
        { headers: HEADERS }
      );
      // console.log("res", response);
      if (response.data.response_code === "0000") {
        const { value: otp } = await Swal.fire({
          html: `
                <div>
                  <h5><strong>Enter OTP</strong></h5>
                  <span style="display: block; font-size:16px; text-align: left; margin-bottom: 5px;">
                    One Time Password (OTP)
                  </span>
                  <input id="swal-otp" class="form-control" placeholder="Enter OTP" maxlength="6">
                  <span class="mt-2" style="display: block; font-size:14px; text-align: left; margin-bottom: 5px;">
                    Note: OTP has been sent to your registered phone number.
                  </span>
                </div>
              `,
          showCancelButton: true,
          confirmButtonText: "Verify",
          cancelButtonText: "Cancel",
          reverseButtons: true,
          inputValidator: (value) => {
            if (!value) {
              return "Please enter the OTP!";
            }
          },
          customClass: {
            confirmButton: "swal-custom-confirm-btn",
          },
          preConfirm: () => {
            const otpValue = document.getElementById("swal-otp").value;
            if (!otpValue || otpValue.length !== 6 || !/^\d+$/.test(otpValue)) {
              Swal.showValidationMessage("Please enter a valid 6-digit OTP");
              return false;
            }
            return otpValue;
          },
        });
        if (response?.data?.response_code === "0000") {
          // console.log("res", response);
          const { plan_price, account_number, trans_id } =
            response?.data?.data || {};
          if (otp) {
            // console.log("Entered OTP:", otp);
            const verifyPayload = {
              valid_otp: otp,
              plan_price,
              account_number,
              trans_id: trans_id?.toString() || "",
            };
            try {
              const verifyResponse = await axios.post(
                OtpVerifyOuter,
                JSON.stringify(verifyPayload),
                { headers: HEADERS }
              );
              if (verifyResponse?.data?.response_code === "0000") {
                // console.log("resp", verifyResponse);
                Swal.fire({
                  icon: "success",
                  title: "OTP Verified",
                  text:
                    verifyResponse.data.response_description ||
                    "Subscription completed successfully!",
                  confirmButtonColor: "#2D7D9F",
                }).then(async () => {
                  // navigate("/login");
                  const form1Valid = Object.keys(errorsForm1).length === 0;
                  const form2Valid = Object.keys(errorsForm2).length === 0;

                  if (form1Valid && form2Valid) {
                    const { terms, confirm_users_password, ...restForm1 } =
                      formData.form1;
                    const combinedData = {
                      ...restForm1,
                      ...formData.form2,
                      company_size: parseInt(getValues("company_size"), 10),
                      plan_id: selectedPlanId,
                    };

                    // console.log("combinedData", combinedData);

                    const registerServiceResponses = await RegisterService(
                      combinedData
                    );
                    if (registerServiceResponses.response_code === "0000") {
                      const userIdFromResponse =
                        registerServiceResponses?.data?.[0]?.userid;
                      // console.log("response success", registerServiceResponses);
                      setUserId(userIdFromResponse);
                      setStep(4);

                      Swal.fire({
                        icon: "success",
                        title: "Registration Successful!",
                        text: "User registered successfully.",
                        confirmButtonColor: "#2d7d9f",
                        confirmButtonText: "OK",
                      }).then(() => {
                        navigate("/login");
                      });
                    } else {
                      setErrorMessage(
                        registerServiceResponses.response_description
                      );
                      // console.log("failed", registerServiceResponses);
                    }
                  }
                });
              } else {
                // console.log("res", verifyResponse);
                Swal.fire({
                  icon: "error",
                  title: "OTP Verification Failed",
                  text:
                    verifyResponse.data.response_description ||
                    "Invalid OTP or verification failed.",
                  confirmButtonColor: "#2D7D9F",
                });
              }
            } catch (error) {
              // console.error("OTP verification error:", error);
              Swal.fire({
                icon: "error",
                title: "Error",
                text: "Something went wrong during OTP verification.",
                confirmButtonColor: "#2D7D9F",
              });
            }
          }
        }
      } else {
        Swal.fire("Error", response.data.response_description, "error");
      }
    } catch (error) {
      Swal.fire("Error", "Something went wrong", "error");
    }
  };

  useEffect(() => {
    const fetchCountries = async () => {
      const countryPhoneCodeServiceResponse = await CountryPhoneCodeService();
      // console.log("country code", countryPhoneCodeServiceResponse);
      setCountries(countryPhoneCodeServiceResponse.data || []);
    };
    fetchCountries();
  }, []);

  useEffect(() => {
    const fetchCompanySize = async () => {
      try {
        const companySizeServiceResponse = await CompanySizeService();
        if (companySizeServiceResponse.response_code === "0000") {
          // console.log("size", companySizeServiceResponse);
          setCompanySize(companySizeServiceResponse.data || []);
        } else {
          setCompanySize([]);
        }
      } catch (error) {
        // console.error("Error fetching company size data:", error);
        setCompanySize([]);
      }
    };
    fetchCompanySize();
  }, []);

  function checkEmail(event) {
    const userEmail = event.target.value;
    if (!userEmail) return;

    fetch(CheckUserEmail, {
      method: "POST",
      headers: HEADERS,
      body: JSON.stringify({ email: userEmail }),
    })
      .then((response) => response.json())
      .then((data) => {
        if (data.response_code === "0000") {
          setErrorMessage("");
        } else {
          setErrorMessage(data.response_description);
        }
      })
      .catch((error) => {
        // console.error("Error:", error);
        setErrorMessage("Error validating email");
      });
  }

  function checkOrgaName(event) {
    const orgName = event.target.value;
    if (!orgName) return;

    fetch(checkOrgName, {
      method: "POST",
      headers: HEADERS,
      body: JSON.stringify({ organization_name: orgName }),
    })
      .then((response) => response.json())
      .then((data) => {
        if (data.response_code === "0000") {
          setErrorMessage1("");
        } else {
          setErrorMessage1(data.response_description);
        }
      })
      .catch((error) => {
        console.error("Error:", error);
        setErrorMessage1("Error validating organization name");
      });
  }

  function checkOrgaCode(event) {
    const orgCode = event.target.value;
    if (!orgCode) return;

    fetch(checkOrgCode, {
      method: "POST",
      headers: HEADERS,
      body: JSON.stringify({ organization_id: orgCode }),
    })
      .then((response) => response.json())
      .then((data) => {
        if (data.response_code === "0000") {
          setErrorMessage2("");
        } else if (data.response_code === "2006") {
          setErrorMessage2(`Organization code ${orgCode} already exists.`);
        } else {
          setErrorMessage2("Invalid organization code");
        }
      })
      .catch((error) => {
        console.error("Error:", error);
        setErrorMessage2("Error validating organization code");
      });
  }
  const [errorMessage, setErrorMessage] = useState("");
  const [errorMessage1, setErrorMessage1] = useState("");
  const [errorMessage2, setErrorMessage2] = useState("");
  const navigate = useNavigate();
  const handleAgreeClick = () => {
    navigate("/privacy-policy");
  };

  return (
    <React.Fragment>
      {step === 1 && (
        <div className="registration-form-container ">
          <nav className="navbar">
            <a href="." className="logo">
              <img src={logo} alt="" />
            </a>
          </nav>
          <h2 className="form-title text-uppercase">Company Registration</h2>
          <div className="registration-form shadow">
            <h2>Sign Up</h2>
            <div className="progress-dots">
              <span className={`dot ${step >= 1 ? "active" : ""}`}></span>
              <div className={`connector ${step >= 1 ? "active" : ""}`}></div>
              <span className={`dot ${step >= 2 ? "active" : ""}`}></span>
              <div className={`connector ${step >= 2 ? "active" : ""}`}></div>
              <span className={`dot ${step >= 3 ? "active" : ""}`}></span>
            </div>
            <form
              onSubmit={handleSubmitForm1(onSubmitForm1)}
              className="input-form"
            >
              <div className="form-group">
                <label>Email</label>
                <input
                  className="form-control"
                  type="email"
                  placeholder="Enter your email"
                  {...registerForm1("users_email", {
                    required: "Email is required",
                    pattern: {
                      value: /^\S+@\S+$/i,
                      message: "Please enter a valid email address",
                    },
                  })}
                  onBlur={(e) => {
                    setErrorMessage("");
                    checkEmail(e);
                  }}
                />
                {errorsForm1.response && (
                  <span
                    style={{ color: "red", fontSize: "14px" }}
                    className="warning"
                  >
                    {errorsForm1.response.response_description}
                  </span>
                )}
                {errorMessage && (
                  <span
                    style={{ color: "red", fontSize: "14px" }}
                    className="warning"
                  >
                    {errorMessage}
                  </span>
                )}
              </div>
              <div className="form-group mt-2">
                <label>Password</label>
                <input
                  className="form-control"
                  type="password"
                  placeholder="Enter your password"
                  {...registerForm1("users_password", {
                    required: "Password is required",
                    minLength: {
                      value: 5,
                      message: "Password should have at least 5 characters",
                    },
                  })}
                />
                {errorsForm1.users_password && (
                  <span style={{ color: "red", fontSize: "14px" }}>
                    {errorsForm1.users_password.message}
                  </span>
                )}
              </div>
              <div className="form-group mt-2">
                <label>Confirm Password</label>
                <input
                  className="form-control"
                  type="password"
                  placeholder="Confirm your password"
                  {...registerForm1("confirm_users_password", {
                    required: "Please confirm your password",
                    validate: (value) =>
                      value === passwordForm1 || "Passwords do not match",
                  })}
                />
                {errorsForm1.users_password && (
                  <span style={{ color: "red", fontSize: "14px" }}>
                    {errorsForm1.users_password.message}
                  </span>
                )}
              </div>
              <div
                className="form-group terms gap-2 mt-3 mb-3"
                style={{ display: "flex", alignItems: "center" }}
              >
                <input
                  type="checkbox"
                  id="terms"
                  {...registerForm1("terms", { required: "*" })}
                  style={{ marginRight: "5px", width: "15px", height: "15px" }}
                />
                <span
                  style={{ fontSize: "14px", color: "#505050 !important" }}
                  className="condition"
                >
                  I agree to the{" "}
                  <a
                    onClick={handleAgreeClick}
                    style={{ cursor: "pointer", color: "#2d7d9f" }}
                  >
                    terms and conditions
                  </a>
                </span>
                {errorsForm1.terms && (
                  <span style={{ color: "red", fontSize: "14px" }}>
                    {errorsForm1.terms.message}
                  </span>
                )}
              </div>
              <button
                type="submit"
                className="company-submit"
                disabled={Object.keys(errorsForm1).length > 0 || errorMessage}
              >
                Next
              </button>
            </form>
          </div>
        </div>
      )}
      {step === 2 && (
        <div className="registration-form-container">
          <nav className="navbar">
            <a href="." className="logo">
              <img src={logo} alt="" />
            </a>
            <input type="checkbox" className="menu-btn" id="menu-btn" />
            <label className="menu-icon" htmlFor="menu-btn">
              <span className="nav-icon"></span>
            </label>
          </nav>
          <h2 className="form-title">Company Registration</h2>
          <div className="registration-form shadow">
            <h2>Tell us about yourself</h2>
            <div className="progress-dots">
              <span className={`dot ${step >= 1 ? "active" : ""}`}></span>
              <div
                className={`connector active-pro ${step >= 1 ? "active" : ""}`}
              ></div>
              <span
                className={`dot dot-pro ${step >= 2 ? "active" : ""}`}
              ></span>
              <div className={`connector ${step >= 2 ? "active" : ""}`}></div>
              <span className={`dot ${step >= 3 ? "active" : ""}`}></span>
            </div>
            <form
              onSubmit={handleSubmitForm2(onSubmitForm2)}
              className="input-form"
            >
              <div className="form-group">
                <label>First Name</label>
                <input
                  className="form-control"
                  type="text"
                  placeholder="Enter your first name"
                  {...registerForm2("first_name", {
                    required: "First name is required",
                    pattern: {
                      value: /^[A-Za-z]{3,150}$/,
                      message: "Please enter a valid first name",
                    },
                  })}
                />
                {errorsForm2.first_name && (
                  <span style={{ color: "red", fontSize: "14px" }}>
                    {errorsForm2.first_name.message}
                  </span>
                )}
              </div>

              <div className="form-group">
                <label>Last Name</label>
                <input
                  className="form-control"
                  type="text"
                  placeholder="Enter your last name"
                  {...registerForm2("last_name", {
                    pattern: {
                      value: /^[A-Za-z]{3,150}$/,
                      message: "Please enter a valid last name",
                    },
                  })}
                />
                {errorsForm2.last_name && (
                  <span style={{ color: "red", fontSize: "14px" }}>
                    {errorsForm2.last_name.message}
                  </span>
                )}
              </div>

              <div className="form-group">
                <label>Company Name</label>
                <input
                  className="form-control"
                  type="text"
                  placeholder="Enter company name"
                  {...registerForm2("organization_name", {
                    required: "Company name is required",
                  })}
                  onBlur={checkOrgaName}
                />
                {errorMessage1 && (
                  <span style={{ color: "red", fontSize: "14px" }}>
                    {errorMessage1}
                  </span>
                )}
                {errorsForm2.organization_name && (
                  <span style={{ color: "red", fontSize: "14px" }}>
                    {errorsForm2.organization_name.message}
                  </span>
                )}
              </div>

              <div className="form-group">
                <label>Company Code</label>
                <input
                  type="text"
                  placeholder="Enter company code"
                  {...registerForm2("organization_id", {
                    required: "Company code is required",
                  })}
                  maxLength="2"
                  minLength="2"
                  onBlur={checkOrgaCode}
                />
                {errorMessage2 && (
                  <span style={{ color: "red", fontSize: "14px" }}>
                    {errorMessage2}
                  </span>
                )}
                {errorsForm2.organization_id && (
                  <span style={{ color: "red", fontSize: "14px" }}>
                    {errorsForm2.response.response_description}
                  </span>
                )}
              </div>

              <div className="form-group pb-1">
                <label>Industry Type</label>
                <select
                  className="form-select "
                  {...registerForm2("industry_type", {
                    required: "Industry type is required",
                  })}
                >
                  <option value="">Select Industry Type</option>
                  <option value="Education">Education</option>
                  <option value="Finance">Finance</option>
                  <option value="Business">Business</option>
                  <option value="Technology">Technology</option>
                  <option value="Healthcare">Healthcare</option>
                </select>
                {errorsForm2.industry_type && (
                  <span style={{ color: "red", fontSize: "14px" }}>
                    {errorsForm2.industry_type.message}
                  </span>
                )}
              </div>

              <div className="form-group mt-1 pb-1 d-none">
                <label htmlFor=" ">Company Size</label>
                <select
                  className="form-select"
                  {...registerForm2("company_size", {
                    required: "Please select company size",
                  })}
                >
                  <option value="" disabled>
                    Select Company Size
                  </option>
                  {companySize.map((option, index) => (
                    <option key={index} value={option.id}>
                      {option.size_range}
                    </option>
                  ))}
                </select>
                {errorsForm2.company_size && (
                  <span
                    style={{ color: "red", fontSize: "14px" }}
                    className="warning"
                  >
                    {errorsForm2.company_size.message}
                  </span>
                )}
              </div>
              <div
                className="mt-1"
                style={{ display: "flex", flexDirection: "row", gap: "1rem" }}
              >
                <div style={{ width: "70%", height: "40%" }}>
                  <div className="form-group">
                    <label>Country Code</label>
                    <select
                      className="form-select"
                      {...registerForm2("country", {
                        required: "Please select an option",
                      })}
                    >
                      {countries.map((option, index) => (
                        <option key={index} value={option.country_code}>
                          {option.country_code}
                        </option>
                      ))}
                    </select>
                    {errorsForm2.country && (
                      <span style={{ color: "red", fontSize: "14px" }}>
                        {errorsForm2.country.message}
                      </span>
                    )}
                    <div></div>
                  </div>
                </div>
                <div className="form-group">
                  <label>Phone Number</label>
                  <input
                    className="form-control"
                    type="tel"
                    placeholder="Enter phone number"
                    {...registerForm2("phone_number", {
                      required: "Phone number is required",
                      pattern: {
                        value: /^[0-9]{8,20}$/,
                        message: "Please enter a valid phone number",
                      },
                    })}
                  />
                  {errorsForm2.phone_number && (
                    <span style={{ color: "red", fontSize: "14px" }}>
                      {errorsForm2.phone_number.message}
                    </span>
                  )}
                </div>
              </div>
              <br></br>
              <button
                type="submit"
                className="company-submit"
                disabled={
                  Object.keys(errorsForm2).length > 0 ||
                  errorMessage1 ||
                  errorMessage2
                }
              >
                Next
              </button>
            </form>
          </div>
        </div>
      )}
      {step === 3 && (
        <>
          <div className="registration-form-container2">
            <nav className="navbar">
              <a href="." className="logo">
                <img src={logo} alt="" />
              </a>
            </nav>
            <h2 className="form-title">Company Registration</h2>
            <div className="confirm-form shadow">
              <h2>Please Vefiy your Information</h2>
              <div className="success-msg d-flex flex-column gap-1 mt-4 ">
                <div className="d-flex flex-row " style={{ width: "100%" }}>
                  <strong className="side-title">Name</strong>
                  <span>
                    : {formData.form2.first_name} {formData.form2.last_name}
                  </span>
                </div>
                <div className="d-flex flex-row " style={{ width: "100%" }}>
                  <strong className="side-title">Email</strong>
                  <span>: {formData.form1.users_email}</span>
                </div>
                <div
                  className="d-flex flex-row align-items-center"
                  style={{ width: "100%" }}
                >
                  <strong className="side-title">Password</strong>
                  <span>
                    :{" "}
                    {isPasswordVisible
                      ? formData.form1.users_password
                      : "******"}
                  </span>
                  <button
                    className=" align-items-center d-flex justify-content-center"
                    type="button"
                    onClick={togglePasswordVisibility}
                    style={{
                      fontSize: "12px",
                      width: "50px",
                      background: "#2d7d9f",
                      color: "#fff",
                      marginLeft: "10px",
                      borderRadius: "100px",
                      height: "20px",
                      cursor: "pointer",
                    }}
                  >
                    {isPasswordVisible ? "Hide" : "Show"}
                  </button>
                </div>
                <div className="d-flex flex-row " style={{ width: "100%" }}>
                  <strong className="side-title">Company Name</strong>
                  <span>: {formData.form2.organization_name}</span>
                </div>
                <div className="d-flex flex-row " style={{ width: "100%" }}>
                  <strong className="side-title">Company Code</strong>
                  <span>: {formData.form2.organization_id}</span>
                </div>
                <div className="d-flex flex-row " style={{ width: "100%" }}>
                  <strong className="side-title">Industry Type</strong>
                  <span>: {formData.form2.industry_type}</span>
                </div>
                <div className="d-flex flex-row " style={{ width: "100%" }}>
                  <strong className="side-title">Phone Number</strong>
                  <span>: {formData.form2.phone_number}</span>
                </div>
              </div>
              {(selectedPlanId === 1 || Number.isNaN(selectedPlanId)) && (
                <button
                  type="submit"
                  onClick={handleCombinedSubmit}
                  className="company-submit mt-4"
                >
                  Submit
                </button>
              )}

              {(selectedPlanId === 2 || selectedPlanId === 3) && (
                <div className="mt-4">
                  <label htmlFor="accountNumber">
                    <strong>Enter DK Account Number:</strong>
                  </label>
                  <input
                    type="text"
                    className="form-control mt-2"
                    placeholder="Account number"
                    value={accountNumber}
                    onChange={(e) => {
                      const numericValue = e.target.value.replace(
                        /[^0-9]/g,
                        ""
                      );
                      const limitedValue = numericValue.slice(0, 12);
                      setAccountNumber(limitedValue);
                    }}
                    maxLength={12}
                    pattern="[0-9]{0,12}"
                    title="Please enter up to 12 digits"
                    required
                  />

                  <div className="row">
                    <div className="col-12">
                      <div className="d-flex justify-content-end">
                        <div className="ms-auto d-flex gap-3">
                          <Link to="/" className="text-decoration-none">
                            <button className="button-cancel company-submit mt-3">
                              Cancel
                            </button>
                          </Link>
                          <button
                            className="button-pred company-submit mt-3"
                            onClick={handleAccountSubmit}
                          >
                            Proceed
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              )}
            </div>
          </div>
        </>
      )}

      {step === 4 && (
        <div className="registration-form-container2">
          <nav className="navbar">
            <a href="." className="logo">
              <img src={logo} alt="" />
            </a>
          </nav>
          <h2 className="form-title">Company Registration</h2>
          <div className="confirm-form shadow">
            <h2>Registration successful</h2>
            <div className="progress-dots"></div>
            <div className="success-msg">
              <p>
                Your settings have been successfully saved. Please note that
                your login credentials and account details have been sent to
                your email address.
              </p>
            </div>
            <Link to="/login">
              <button type="submit" className="company-submit mt-4">
                OK
              </button>
            </Link>
          </div>
        </div>
      )}

      {step === 5 && (
        <div className="registration-form-container2">
          <nav className="navbar">
            <a href="." className="logo">
              <img src={logo} alt="" />
            </a>
          </nav>
          <h2 className="form-title">Company Registration</h2>
          <div className="registration-form shadow">
            <h2>Registration unsuccessful</h2>
            <div className="progress-dots"></div>
            <div className="success-msg">
              <p>Your settings have been not successful.</p>
            </div>
            <Link to="/login">
              <button type="submit" className="company-submit mt-4">
                OK
              </button>
            </Link>
          </div>
        </div>
      )}
    </React.Fragment>
  );
};
export { Registration };
